<template>
  <div
    v-loading="transcriptionInProgress"
    :element-loading-text="$t('transcription.loading')"
    class="side-panel"
  >
    <BTabs
      v-model="activeTab"
      class="tabs"
      :label-items="labelItems"
      :disabled="!transcriptionExists"
    >
      <template #summarization>
        <div
          v-if="transcriptionExists"
          class="side-panel-tab-content-container"
        >
          <TranscriptionSummarization
            :zoom-phone-result-id="zoomPhoneResultId"
            :is-transcription-result-empty="isTranscriptionResultEmpty"
            @click:play-at="handleClickPlayAt"
            @update:summarized-result="handleUpdateSummarizedResult"
          />
        </div>
      </template>
      <template #timeline>
        <div
          v-if="transcriptionExists"
          class="side-panel-tab-content-container"
        >
          <TranscriptionTimeline
            :zoom-phone-result-id="zoomPhoneResultId"
            :is-transcription-result-empty="isTranscriptionResultEmpty"
            @click:play-at="handleClickPlayAt"
          />
        </div>
      </template>
    </BTabs>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TranscriptionSummarization from '@/components/organisms/va-app/transcription/TranscriptionSummarization.vue';
import TranscriptionTimeline from '@/components/organisms/va-app/transcription/TranscriptionTimeline.vue';

type TProps = {
  zoomPhoneResultId: number;
  transcriptionExists: boolean;
  isTranscriptionResultEmpty: boolean;
  transcriptionInProgress: boolean;
  rightAfterTranscription: boolean;
};
type TEmits = {
  'click:playAt': [time: number];
  'update:summarizedResult': [summarizedResult: string | undefined];
}
defineProps<TProps>();
const emit = defineEmits<TEmits>();

const i18n = useI18n();

const labelItems = [
  {
    slotName: 'summarization',
    label: i18n.t('transcription.summarization'),
  },
  {
    slotName: 'timeline',
    label: i18n.t('transcription.timeline'),
  },
];

const activeTab = ref('summarization');

const handleClickPlayAt = (time: number) => {
  emit('click:playAt', time);
};

const handleUpdateSummarizedResult = (summarizedResult: string | undefined) => {
  emit('update:summarizedResult', summarizedResult);
};
</script>

<style lang="scss" scoped>
.side-panel {
  padding-top: 14px;
  height: 100%;
}

.tabs {
  height: 100%;
}

.side-panel-tab-content-container {
  height: 100%;
  padding: 20px 32px;
  overflow-y: auto;
}

:deep(.el-tabs__header) {
  margin-bottom: 0;

  .el-tabs__nav-scroll {
    padding: 0 32px;
  }
}

:deep(.el-tabs__content) {
  .el-tab-pane {
    height: 100%;
  }
}
</style>
